import { render, staticRenderFns } from "./EnglishKeyboard.vue?vue&type=template&id=06a4a109&"
import script from "./EnglishKeyboard.vue?vue&type=script&lang=ts&"
export * from "./EnglishKeyboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports